import { useMemo, useState } from 'react'

function CodexDocList({ docs, selectedId, onSelect }) {
  const [showArchived, setShowArchived] = useState(false)
  const activeDocs = useMemo(() => docs.filter((d) => d.status !== 'archived'), [docs])
  const archivedDocs = useMemo(() => docs.filter((d) => d.status === 'archived'), [docs])

  const renderDocButton = (d) => (
    <li key={d.id}>
      <button
        type="button"
        className={`codex-admin-doc-btn ${selectedId === d.id ? 'active' : ''}`}
        onClick={() => onSelect(d.id)}
      >
        <span>{d.published?.title || d.slug || d.id}</span>
        <small>{d.status || 'draft'}</small>
      </button>
    </li>
  )

  return (
    <aside className="codex-admin-list">
      <h3>Fiches</h3>
      <ul>
        {activeDocs.map(renderDocButton)}
      </ul>
      <div className="codex-admin-archived-section">
        <button
          type="button"
          className="codex-admin-archived-toggle"
          onClick={() => setShowArchived((prev) => !prev)}
        >
          {showArchived ? 'Masquer' : 'Afficher'} archivées ({archivedDocs.length})
        </button>
        {showArchived && (
          archivedDocs.length > 0 ? (
            <ul className="codex-admin-archived-list">
              {archivedDocs.map(renderDocButton)}
            </ul>
          ) : (
            <p className="codex-admin-archived-empty">Aucune fiche archivée.</p>
          )
        )}
      </div>
    </aside>
  )
}

export default CodexDocList
